import '../../reset.css';
import '../../style.css';
import 'survey-core/survey-core.min.css';
// import '../styles/surveyInIFrame.css';
import {themeJson as themeJsonIsland} from './_formStylesIsland.js';
import {themeJson as themeJsonHFarm} from './_formStylesHFarm.js';
import {themeJson as themeJsonTLF} from './_formStyles.js';
import {themeJson as themeJsonDP} from './_formStylesDP.js';

import {
  trackApplicationSubmitSuccess,
  userBrowserId,
} from '../../scripts/common.js';

import {Model} from 'survey-core';
import 'survey-js-ui';

import {surveyJson} from './_apply_form.js';
import {applyTimezoneLogic} from '../_timezone-utils.js';
import {setupTelegramAuth} from './_telegram_auth.js';
import {setupFormTracking} from './_formTracking.js';
import {initIframeResize} from '../_inIFrame.js';

import '../_common/my_sentry.js';


// school = "h_farm", "the_island", or null/undefined
export function initApplicationForm(school) {
  let themeJson;
  if (school === "h_farm" || school === "h-farm") {
    themeJson = themeJsonHFarm;
  } else if (school === "the_island") {
    themeJson = themeJsonIsland;
  } else if (school === "dp") {
    themeJson = themeJsonDP;
  } else {
    themeJson = themeJsonTLF;
    school = undefined;
  }

  let finalConfig = surveyJson;
  if (school !== 'dp') {
    finalConfig = applySchoolPreselection(finalConfig, school);
  } else {
    finalConfig = applyAdvancedEntryLogic(finalConfig, true);
  }
  // finalConfig = applySchoolSpecificRequirements(finalConfig, school);
  finalConfig = applyTimezoneLogic(finalConfig);

  const survey = new Model(finalConfig);
  survey.applyTheme(themeJson);
  const changeTimestamps = {};
  let initalPhaseDone = false;
  let autoSaveTimeout = null; // Timer for debouncing server saves

  // Initialize New Telegram Auth Logic
  const telegramAuth = setupTelegramAuth(survey);

  const tracking = setupFormTracking(survey, () => {
    if (initalPhaseDone) saveState(survey);
  });

// 1. Handle File Uploads
  survey.onUploadFiles.add((survey, options) => {
    const formData = new FormData();
    formData.append('userBrowserId', userBrowserId);
    options.files.forEach((file) => {
      formData.append('file', file);
    });

    fetch(`${BACKEND_URL}/api/forms/upload`, {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const successData = options.files.map((file, index) => {
          return {
            file: file,
            // Use the URL returned by the backend so SurveyJS can display/link it
            // data.urls[index] matches the specific file we just uploaded
            content: `${BACKEND_URL}${data.urls[index]}`,
          };
        });
        options.callback('success', successData);
      })
      .catch((error) => {
        console.error('Upload error:', error);
        options.callback('error');
      });
  });

// 2. Handle File Removal
  survey.onClearFiles.add((survey, options) => {
    options.callback('success');
  });


  const storageName = 'TLF_apply_2027';
  const keyAlreadyApplied = 'TLF_apply_success_2027';
  const tlf_connection_code = 'tlf_connection_code';
  const tlf_bot_name = 'tlf_bot_name';


  function getAlreadyApplied() {
    let already = window.localStorage.getItem(keyAlreadyApplied);
    let email;
    let surname;
    let name;
    try {
      already = JSON.parse(atob(already));
      email = already.email;
      surname = already.surname;
      name = already.name;
    } catch (error) {
      return undefined;
    }
    if (email && email.length >= 3 && surname && surname.length >= 1 && name && name.length >= 1) {
      return {email, surname, name};
    } else {
      return undefined;
    }
  }

  function setAlreadyApplied(email, surname, name) {
    const obj = {email, surname, name};
    const objEnc = btoa(JSON.stringify(obj));
    window.localStorage.setItem(keyAlreadyApplied, objEnc);
  }

  async function sendDataToServer(survey, completed = false, options = null) {
    if (completed) {
      options.showDataSaving(`Submitting your data...Please wait while we send your information to the server.`);
      survey.data.full = 'yes';
    }

    const trackingPayload = await tracking.collectPayload();

    // Keep top-level tracking fields for backward compatibility.
    const res = JSON.stringify({
      data: {
        ...survey.data,
        ...trackingPayload,
      },
      changeTimestamps,
      id: userBrowserId,
      completed,
      ...trackingPayload,
    });

    fetch(`${BACKEND_URL}/api/application2027`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: res,
    })
      .then((response) => {
        if (response.status === 201) {
          if (completed) {
            trackApplicationSubmitSuccess({
              customData: {
                program_type: survey.data.program_type || null,
                school_choice: survey.data.school_choice || null,
              },
              userData: {
                email: survey.data.student_email || null,
                phone: survey.data.contact_phone || null,
                firstName: survey.data.student_firstname || null,
                lastName: survey.data.student_lastname || null,
                country: survey.data.residence_country || null,
              },
            });
            try {
              window.ym(99696795, 'reachGoal', 'appl_sumbitted');
            } catch (e) {
              console.error(e);
            }
            try {
              setAlreadyApplied(survey.data.student_email, survey.data.student_lastname, survey.data.student_firstname);
            } catch (e) {
              console.error(e.toString());
            }
            telegramAuth.dispose(true);
            tracking.dispose();
            clearStorage();
          }
        } else {
          throw new Error(`Server responded with status ${response.status}`);
        }
      })
      .catch((error) => {
        if (completed) {
          options.showDataSavingError(`
          Oops! Something went wrong. 
          Your data couldn’t be saved on the server, but don’t worry—it has been stored in your browser. 
          Please try resubmitting it. If it doesn’t work now, you can try again later. 
          Thank you for your patience!
        `);
        }
        console.error('Error:', error);
      });
  }

  // Persists data to LocalStorage AND triggers Server Auto-Save
  function saveState(survey) {
    let data = survey.data;
    if (Object.keys(data).length === 0) {
      const storageSt = window.localStorage.getItem(storageName) || '';
      if (storageSt) data = JSON.parse(storageSt);
    }
    const res = {currentPageNo: survey.currentPageNo, data, changeTimestamps};

    // 1. Local Storage (Immediate)
    window.localStorage.setItem(storageName, JSON.stringify(res));

    // 2. Server Draft Save (Debounced)
    const formId = survey.data.form_id; // Check if we have a draft ID
    if (formId) {
      if (autoSaveTimeout) clearTimeout(autoSaveTimeout);

      autoSaveTimeout = setTimeout(() => {
        fetch(`${BACKEND_URL}/api/application_save_draft`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            form_id: formId,
            payload: survey.data,
            idd: userBrowserId,
          }),
        }).catch((e) => console.error("Auto-save failed", e));
      }, 2000); // 2 seconds delay
    }
  }

  function loadState(survey) {
    const storageSt = window.localStorage.getItem(storageName) || '';
    let res = {};
    if (storageSt) res = JSON.parse(storageSt);

    if (res.data) survey.data = res.data;
    if (res.currentPageNo) survey.currentPageNo = res.currentPageNo;
  }

  function clearStorage() {
    window.localStorage.removeItem(storageName);
    // Also clear auth keys
    window.localStorage.removeItem(tlf_connection_code);
    window.localStorage.removeItem(tlf_bot_name);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const formContainer = document.getElementById('application-form');
    if (formContainer) {
      loadState(survey);
      if (school === 'dp') {
        survey.setValue('program_type', '2_year');
      } else if (school) {
        survey.setValue('school_choice', school);
      }
      tracking.fillMissingTrackingDataFromStorage();
      initalPhaseDone = true;

      survey.onValueChanged.add(function (survey, options) {
        saveState(survey);
      });
      survey.onCurrentPageChanged.add(function (survey, options) {
        if (initalPhaseDone) {
          saveState(survey);
        }
      });
      survey.onPartialSend.add(function (survey, options) {
        saveState(survey);
      });
      survey.onComplete.add(function (survey, options) {
        saveState(survey);
        void sendDataToServer(survey, true, options);
      });

      survey.render(formContainer);
    } else {
      console.error('Element #application-form not found');
    }
  });


  document.addEventListener('DOMContentLoaded', () => {
    const data = getAlreadyApplied();
    if (data) {
      const container = document.getElementById('already-applied-message');
      if (container) {
        container.innerHTML = `
          <div class="bg-green-100 border border-green-300 text-green-800 p-4 mb-4 rounded">
            <p>
              Your application has already been successfully saved under the name
              <strong>${data.name} ${data.surname}</strong> with the email address
              <strong>${data.email}</strong>.
            </p>
          </div>
        `;
      }
    }
  });

  initIframeResize();
}


/**
 * Modifies the SurveyJS config to pre-select a specific school and adjust privacy text.
 */
function applySchoolPreselection(config, schoolSelected) {
  if (!schoolSelected) {
    return config;
  }

  config.clearInvisibleValues = "none";

  const schoolPage = config.pages.find(p => p.name === "school_selection");
  if (schoolPage) {
    schoolPage.visible = false;
    const schoolQuestion = schoolPage.elements.find(e => e.name === "school_choice");
    if (schoolQuestion) {
      schoolQuestion.defaultValue = schoolSelected;
    }
  }

  const privacyPage = config.pages.find(p => p.name === "privacy_consent_page");
  if (privacyPage) {
    const privacyHtmlQuestion = privacyPage.elements.find(e => e.type === "html");
    if (privacyHtmlQuestion) {
      privacyHtmlQuestion.html = "<h5>Privacy Notice</h5><p>By checking the box below, you consent to the processing of personal data for the admission process, including sharing data with the Technology Leaders of the Future program office. For more details, please review their <a href='https://leaders.tech/en/privacy.html?headless=true' target='_blank' style='color: #0088cc; text-decoration: underline;'>Privacy Policy</a>.</p>";
    }
  }

  return config;
}

function applySchoolSpecificRequirements(config, schoolSelected) {
  if (schoolSelected !== 'h_farm' && schoolSelected !== 'h-farm') {
    return config;
  }

  for (const page of config.pages) {
    if (!page.elements) {
      continue;
    }
    const transcriptsField = page.elements.find((element) => element.type === 'file' && element.name === 'school_transcripts');
    if (transcriptsField) {
      transcriptsField.isRequired = true;
      break;
    }
  }

  return config;
}


/**
 * Modifies the SurveyJS config for the "Advanced Entry" (A-level Year 1) scenario.
 */
export function applyAdvancedEntryLogic(config, isAdvancedEntry) {
  // If not advanced entry mode, return config as is
  if (!isAdvancedEntry) {
    return config;
  }

  // 1. Create a deep copy to avoid mutating the original
  const newConfig = JSON.parse(JSON.stringify(config));

  // Helper to find question across pages
  function findQuestion(name, type = null) {
    for (const page of newConfig.pages) {
      if (page.elements) {
        const el = page.elements.find((e) => e.name === name && (!type || e.type === type));
        if (el) return el;
      }
    }
    return null;
  }

  // 2. Hide the "advanced_entry_info" HTML block
  const infoBlock = findQuestion("advanced_entry_info");
  if (infoBlock) {
    infoBlock.visible = false;
  }

  // Ensure transcript notice text stays readable in the advanced entry theme.
  const transcriptInfo = findQuestion("school_transcripts", "html");
  if (transcriptInfo?.html) {
    transcriptInfo.html = transcriptInfo.html.replace(
      /<div style='/,
      "<div style='color: #111827; "
    );
  }

  // 3. Modify the "program_type" question
  const programQuestion = findQuestion("program_type");
  if (programQuestion) {
    programQuestion.title = "Advanced Entry Application (Supplementary Intake)";
    programQuestion.description = "You are applying for a direct entry into the 2nd year of studies (A-level Year 1 / Grade 11). This is not a standard admission track.";

    // Set the single choice
    programQuestion.choices = [
      {
        value: "2_year",
        text: "Starting from the second year of our 3-Year Program (Starts from A-level Year 1 / Grade 11). Recommended age: 16-17."
      }
    ];

    // Auto-select the only option
    programQuestion.defaultValue = "2_year";

    // Update validators for the older age group (approx 2008-2009 for 16-17 y.o.)
    programQuestion.validators = [
      {
        type: "expression",
        text: "For the 2-Year Advanced Entry, the date of birth must be roughly between Sep 1, 2009 and Dec 12, 2012.",
        expression: "{program_type} != '2_year' or ({student_dob} >= '2009-09-01' and {student_dob} <= '2012-12-12')"
      }
    ];
  }

  const motivationQuestion = findQuestion("other_achievements");
  if (motivationQuestion) {
    motivationQuestion.title = "Motivation Letter";
    motivationQuestion.description = "Since this is an exceptional entry track, please explain why we should consider your application. Describe your technology/entrepreneurship projects and specific reasons why you are qualified to join the program at an advanced stage.";
    motivationQuestion.isRequired = true;
  }

  const diplomasQuestion = findQuestion("diplomas_upload");
  if (diplomasQuestion) {
    diplomasQuestion.title = "Evidence of Exceptional Ability";
    diplomasQuestion.description = "Please attach diplomas, certificates, or portfolios that convincingly prove your outstanding abilities mentioned in your letter. For Advanced Entry, we strictly require significant National or International level achievements.";
  }

  return newConfig;
}
